// 'free',      // Бесплатная начальная подписка для теста интеграции с API
// 'created',   // Подписка создана, но не оплачена (небыло уведомления об оплате от Paddle)
// 'paid',      // Оплачена
// 'refunded',  // Деньги за подписку возвращены
// 'cancelled', // Отменена
// 'payment_failed' // Проблема с оплатой

import { Chip } from '@material-ui/core';

export default function PayStatus({ status }) {
    const color = {
        'free': 'primary',
        'created': 'primary',
        'refunded': 'primary',
        'payment_failed': 'error',
        'paid': 'success',
        'cancelled': 'warning',
    }[status]
    return status && color && <Chip color={color} label={status} size="small" />;
}